export default {
  width: 0,
  id: 'formattedInvoicedDate',
  accessor: row => row.formattedInvoicedDate,
  resizable: false,
  Cell: () => null
};
